export default "__VITE_ASSET__BMjm6Bbp__"